import Const from '@/util/Const'

export default class BusinessCondition {

  public static all(): BusinessCondition[] {
    return [
      new BusinessCondition('1', Const.label('Portfolio.Question1.choice1')),
      new BusinessCondition('2', Const.label('Portfolio.Question1.choice2')),
      new BusinessCondition('3', Const.label('Portfolio.Question1.choice3')),
      new BusinessCondition('4', Const.label('Portfolio.Question1.choice4')),
      new BusinessCondition('5', Const.label('Portfolio.Question1.choice5')),
      new BusinessCondition('6', Const.label('Portfolio.Question1.choice6')),
    ]
  }

  public static find(code: string): BusinessCondition | undefined {
    return BusinessCondition
      .all()
      .find((bc) => bc.code === code)
  }

  public code: string
  public label: string

  constructor(code: string, label: string) {
    this.code = code
    this.label = label
  }
}
